export interface SurveyData {
    id?: number;
    userId?: number;
    getDate?: string;
    hour?: string;
    gender: string;
    origin: string;
    destination: string;
    reason: string;
    occupants: number;
}

export interface ResumedSurveyData {
    id: number;
    userId: number;
    date?: string;
}

export function createEmptySurvey(): SurveyData {
    return {
        gender: '',
        origin: '',
        destination: '',
        reason: '',
        occupants: 0,
    };
}
